/** Общие параметры компонента ошибки для HTML сборки и первого открытия приложения. */
export function notFoundPageProps(kind, t, clubSlug, locale) {
  const home = locale === 'ru' ? '/ru/' : '/';
  const clubPath = `${home}${encodeURIComponent(clubSlug || '')}`;
  if (kind === 'tournament') return {
    title: t('tournamentPage.notFound.title'), description: t('tournamentPage.notFound.description'),
    actionLabel: t('tournamentPage.notFound.action'), backTo: `${clubPath}/tournaments`,
  };
  if (kind === 'season') return {
    title: t('seasonPage.notFoundTitle'), description: t('seasonPage.notFoundText'),
    actionLabel: t('seasonPage.backToSeasons'), backTo: `${clubPath}/seasons`,
  };
  return { title: t('notFound.title'), backTo: home };
}
